<template>
    <div>
        <el-dialog title="" :visible.sync="detailsShow" :close-on-click-modal="false" width="70%" ref="dialog"
            @close="invoiceClose" top="5vh">
            <div>
                <div style="text-align: right;">
                    <el-button type="primary" size="small" icon="el-icon-download" v-if="tag <= 3"
                        @click="downloadFileDeatil()">下载开票详情</el-button>

                    <el-button type="primary" size="small" icon="el-icon-download" v-if="tag <= 3"
                        @click="downloadFile()">下载订单信息</el-button>
                    <!-- 电子票不能“确认开票” -->
                    <el-button type="primary" size="small" @click="confirmInc()" v-if="tag <= 2&&info&&info.InvoiceInfo&&!info.InvoiceInfo.IsEInvoice">确认开票</el-button>
                
                    <!-- 电子票不能“拒绝开票” -->
                    <el-button type="danger" size="small" @click="refusedInvoiceShow = true; textarea2 = ''"
                        v-if="tag <= 2&&info&&info.InvoiceInfo&&!info.InvoiceInfo.IsEInvoice">拒绝开票</el-button>

                    <!-- TIPS：只在待回款时候存在 250905-->
                    <el-button type="primary" size="small" @click="confirmReturn()" v-if="info&&info.InvoiceInfo&&info.InvoiceInfo.InvoiceStatus==5">确认回款</el-button>

                    <!--用户申请和后台申请，开票失败的，电子发票重开 -->
                    <el-button type="primary" size="small" @click="reInvoice()" 
                    v-if="tag==2&&info&&info.InvoiceInfo&&info.InvoiceInfo.IsEInvoice&&info.InvoiceInfo.InvoiceStatus==8">重试开票</el-button>

                    <!-- 待回款，电子发票重开 -->
                    <el-button type="primary" size="small" @click="reInvoice()" 
                    v-if="(tag==3||tag==4)&&info&&info.InvoiceInfo&&info.InvoiceInfo.IsEInvoice&&info.InvoiceInfo.InvoiceStatus==5">电子发票重开</el-button>

                    <!-- 已完成-余额的，电子发票重开 -->
                    <el-button type="primary" size="small" @click="reInvoice()" 
                    v-if="(tag==3||tag==4)&&info&&info.InvoiceInfo&&info.InvoiceInfo.InvoiceStatus==3&&info.InvoiceInfo.IsEInvoice&&info.InvoiceInfo.ReceivedMoneyType==2">电子发票重开</el-button>
                   
                    <!-- 已完成-额度的，电子发票重开 -->
                    <el-button type="primary" size="small" @click="reInvoice()" 
                    v-if="(tag==3||tag==4)&&info&&info.InvoiceInfo&&info.InvoiceInfo.InvoiceStatus==3&&info.InvoiceInfo.IsEInvoice&&info.InvoiceInfo.ReceivedMoneyType==1">退回额度并重开电子发票</el-button>
                  
                    <!-- End -->
                </div>
                <el-form :inline="true" label-width="140px" label-position="left" v-loading="loading">
                    <el-row>
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px;">
                                <h3 class="tk-head-title">申请信息</h3>
                            </div>
                        </el-col>
                  
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="账号：" size="medium" class="item-width">
                                <div class="content-color">{{ info.ApplyAccount }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="账号Code：" size="medium" class="item-width">
                                <div class="content-color">{{ info.ApplyUserCode }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="申请人：" size="medium" class="item-width">
                                <div class="content-color">{{ info.ApplyUser }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="申请时间：" size="medium" class="item-width">
                                <div class="content-color">{{ info.ApplyDt || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px;">
                                <h3 class="tk-head-title">发票财务信息</h3>
                            </div>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票编号：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.InvoiceNumber) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="已收金额：" size="medium" class="item-width">
                                <div class="content-color">¥{{ (info.InvoiceInfo&&info.InvoiceInfo.ReceivedMoney) }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="应收金额：" size="medium" class="item-width">
                                <div class="content-color">{{ info.ReceivableMoney || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="回款日期：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.InvoiceReturnPaymentsDt) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px;">
                                <h3 class="tk-head-title">开票信息</h3>
                            </div>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票Id：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.ID) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票抬头类型：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.InvoiceTitleType == 1) ? '企业' : '个人' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票类型：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.IsVatInvoice) ? '增值税专用发票' : '增值税普通发票' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票抬头：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.InvoiceTitle) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="纳税人识别号：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.TaxNo) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="注册地址：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.CompanyAddress) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="注册号码：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.CompanyPhone) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="用户开户银行：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.UserAccountOrgName) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="用户银行账号：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.UserAccountNo) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="开票内容：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.InvoiceContent) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="开票金额：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.InvoiceMoney) | formatPrice }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="开票税点：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.TaxPoint) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票备注：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.InvoiceRemarks) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="是否电子票：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.IsEInvoice?'是':'否') || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="规格型号：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.Specifications) || '-' }}</div>
                            </el-form-item>
                        </el-col> 
                        <el-col :xs="24" :lg="12" v-if="info.InvoiceInfo&&info.InvoiceInfo.IsEInvoice">
                            <el-form-item label="额度/余额发票：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.ReceivedMoneyType==1?'额度':'余额') || '-' }}</div>
                            </el-form-item>
                        </el-col> 
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="银行到账日期：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.InvoiceReturnPaymentsOpDt) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="备注：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.ReceiveMoneyRemark) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px;">
                                <h3 class="tk-head-title">收件信息</h3>
                            </div>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="邮寄地址：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.ExpressAddress) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="收件人：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.Consignee) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="收件人电话：" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.ConsigneePhone) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="用户邮箱:" size="medium" class="item-width">
                                <div class="content-color">{{ (info.InvoiceInfo&&info.InvoiceInfo.InvoiceMailAddress) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                     
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px;">
                                <h3 class="tk-head-title">订单信息</h3>
                                  <el-button size="mini" @click="exportJob" >发票工单下载</el-button>
                            </div>
                        </el-col>

                        <el-col :xs="24">
                            <el-table :data="tableData" border style="width: 100%;" max-height="450">
                                <el-table-column prop="date" label="订单号" width="120" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.OrderNo || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="name" label="订单名称" width="180" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.OrderName || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="来源" width="110" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.OrderSourceStr || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="发单方" width="180" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.SenderName || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="完成时间"  show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.FinishDate || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="金额" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.TotalAmount | formatPrice }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="额度/余额" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.PayType  }}</span>
                                    </template>
                                </el-table-column>
                                 <el-table-column prop="address" label="结算状态" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.SettlementStatus }}</span>
                                    </template>
                                </el-table-column>
                                <!-- 用java接口时备注字段没有对应字段，好像没有意义，暂时保留 -->
                                <el-table-column prop="address" label="备注" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.remark || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="操作" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <el-button size="mini" @click="exportExcel(1, scope.row)">下载</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>

                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px;">
                                <h3 class="tk-head-title">电子发票信息</h3>
                            </div>
                        </el-col>

                        <el-col :xs="24">
                            <el-table :data="eInvoiceList" border style="width: 100%;">
                                <el-table-column prop="date" label="编号" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.Num || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="date" label="发票号码" width="180" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.InvoiceNumber || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="name" label="状态" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.EInvoiceStatusName || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="开票结果" width="150" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.DDZTName || '--' }}</span>
                                    </template>
                                </el-table-column>
                        
                                <el-table-column prop="address" label="开票备注" width="200" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.DDZTXX || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="申请时间" width="200" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.CreateTime || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column prop="address" label="操作" width="180" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.SenderName || '--' }}</span>
                                    </template>
                                </el-table-column>
                                 -->
                                <el-table-column prop="address" label="操作" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <el-button size="mini" v-if="scope.row.EInvoiceStatus==2" @click="disableInvoice(scope.row)">作废</el-button>
                                        <el-button size="mini" v-if="scope.row.FileUrl!=''" @click="downInvoiceFile(scope.row)">查看下载</el-button>
                                        <span v-if="scope.row.DDZT!='030000'">-</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>

                    </el-row>
                    <!-- <el-row type="flex" justify="end">
                        <el-col :span="2">
                            <el-button size="small" @click="exportExcel(2,tableData)">下载全部</el-button>
                            <el-button size="small" @click="downloadFile()">下载全部</el-button>
                        </el-col>
                    </el-row> -->
                </el-form>
                <br />
                <br />
            </div>
        </el-dialog>

        <!-- 确认开票弹窗 -->
        <el-dialog title="确认开票" :visible.sync="confirmInvoiceShow" :close-on-click-modal="false" width="600px"
            ref="dialog" @close="confirmInvoiceClose">
            <el-form label-position="left" label-width="120px">
                <el-form-item label="开票日期：" required>
                    <el-date-picker size="medium" v-model="confirm.time" type="date" placeholder="选择日期"
                        value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" @change="isToday()">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="发票编号：" required>
                    <el-input size="medium" placeholder="请输入发票编号" v-model="confirm.num"></el-input>
                </el-form-item>
                <el-form-item label="预计回款日期：" required>
                    <el-date-picker size="medium" v-model="confirm.time2" type="date" placeholder="选择日期"
                        value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;">
                    </el-date-picker>
                </el-form-item>
                <br />
                <el-form-item label=" ">
                    <el-button type="primary" size="medium" @click="submitInovice()">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <!-- 确认回款弹窗 -->
        <returnedShow ref="returnedShowElem" from="detailsInvoice" @confirmReturnSuccess="confirmReturnSuccess"/>
        
        <!-- 拒绝开票弹窗 -->
        <el-dialog title="拒绝开票" :visible.sync="refusedInvoiceShow" :close-on-click-modal="false" width="600px"
            ref="dialog">
            <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入拒绝开票的原因" v-model.trim="textarea2">
            </el-input>
            <br />
            <br />
            <br />
            <div style="text-align: center;">
                <el-button type="primary" size="medium" @click="refuseBtn()" :loading="loading">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 重开电子票 -->
        <MakeInvoice ref="makeInvoice" />
    </div>
</template>
<script>
//导出excel
import Blob from '@/excel/Blob'
import MakeInvoice from './makeInvoice'
const { export_json_to_excel } = require('@/excel/Export2Excel');
import {
    getStorageUserRoleId,
} from '@/utils/store'
import {
    invoiceManagedetail, confirmInvoiceApi, 
    refuseInvoice, refuseInvoiceReject,
    DisableEInvoice,
    batchInvoiceEcho
} from "@/service/payApi";
import returnedShow from './returnedShow'

export default {
    components: {
        MakeInvoice,
        returnedShow,
    },
    data() {
        return {
            detailsShow: false,             //详情dialog
            confirmInvoiceShow: false,      //确认开票dialog
            confirm: {
                time: new Date(),
                time2: '',
                num: '',
            },
            
            refusedInvoiceShow: false,      //拒绝开票dialog

            textarea2: '',

            tableData: [],
            id: '',
            tag: 1,
            info: {},
            isTodayFlage: true,
            
            loading: false,
            eInvoiceList:[],//电子开票记录
        }
    },
    methods: {
        //下载开票详情
        downloadFileDeatil() {
            const _this = this
            let data = {
                tag: 1,
                platform: 'zyd',
                manageUserId: getStorageUserRoleId(),
                id: this.id,
            }


            let url =
                process.env.NODE_ENV == "development" ?
                    "/api2" :
                    process.env.VUE_APP_API2;

            window.open(
                url + "/gz/admin/download/invoiceManageDetails/download" + "?" + this.parseJsonURL(data)
            );
        },
        //下载订单信息
        downloadFile() {
            const _this = this
            let data = {
                tag: 1,
                platform: 'zyd',
                manageUserId: getStorageUserRoleId(),
                id: this.id,
            }


            let url =
                process.env.NODE_ENV == "development" ?
                    "/api2" :
                    process.env.VUE_APP_API2;

            window.open(
                url + "/gz/admin/download/invoiceManage/workOrderInfo/download" + "?" + this.parseJsonURL(data)
            );
        },
         //下载发票信息
         downInvoiceFile(row) {
            let url =row.FileUrl;
             if(url==''){
                this.$message.error('暂无发票')
                return
             }
            window.open(url);
        },
        //作废发票
        disableInvoice(row){
            const _this = this
            this.$confirm('是否确认作废？', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning'
            }).then(() => {
       
                let data = {
                    EInvoiceId:row.Id
                }
                _this.loading = true
                DisableEInvoice(data).then(r => {
                    _this.loading = false
                    if (r.Result != 1) {
                        return this.$message.error(r.Message)
                    }
                    this.$message.success(r.Message)  
                
                    //重新加载发票信息
                   this.getInvoiceDetail();

                   this.$parent.GetInvoiceList();

                });

            }).catch(() => {});
        },
        parseJsonURL(json) {
            if (!json) return "";
            if (typeof json == "string") return json;
            return this.cleanArray(
                Object.keys(json).map(function (key) {
                    if (json[key] === undefined) return "";
                    return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
                })
            ).join("&");
        },
        cleanArray(actual) {
            var newArray = [];
            for (var i = 0; i < actual.length; i++) {
                if (actual[i]) {
                    newArray.push(actual[i]);
                }
            }
            return newArray;
        },
        //拒绝开票
        refuseBtn() {
            const _this = this
            if (!this.textarea2) {
                return this.$message.error('拒绝开票原因不能为空')
            }
            // var temp = [this.id]
            // var temp2 =[0]
            // var data = {
            //     noteIds : temp2,
            //     orderIds : temp,
            //     refuseReason : this.textarea2,
            // }
            let data = {}
            data.InvoiceId = _this.Id
            data.IsGkInvoice = _this.info.InvoiceInfo.IsGkInvoice
            data.ManageUserId = getStorageUserRoleId()
            data.Platform = 'zyd'
            data.RefuseReason = _this.textarea2
            _this.loading = true
            refuseInvoiceReject(data).then(r => {
                _this.loading = false
                if (r.Result != 1) {
                    return this.$message.error(r.Message)
                }
                this.$message.success('拒绝开票成功')
                this.refusedInvoiceShow = false
                this.detailsShow = false

                this.$parent.GetInvoiceList();
            })
            // refuseInvoice(data).then((r)=>{
            //     _this.loading = false
            //     if(r.Result != 1) {
            //         return this.$message.error(r.Message)
            //     }
            //     this.$message.success('拒绝开票成功')
            //     this.refusedInvoiceShow=false
            //     this.detailsShow = false
            //     this.$parent.GetInvoiceList()
            // })
        },
        
        //显示确认回款弹窗
        confirmReturn() {
            this.returnAmount='';
            this.$refs.returnedShowElem.open(this.info.InvoiceInfo, this.id, this.info.IsHasJobDetail)
        },
        confirmReturnSuccess() {
            this.detailsShow = false
            this.$parent.GetInvoiceList();//刷收款管理-发票管理列表
        },
        isToday() {
            this.isTodayFlage = false
        },
        //确认开票弹窗
        confirmInc() {
            this.confirmInvoiceShow = true;
            this.confirm.num = this.info.invoiceNumber
        },
        //确认开票提交
        submitInovice() {
            const _this = this
            if (!this.confirm.time) {
                this.$message.error('开票日期不能为空')
                return
            }
            if (!this.confirm.num) {
                this.$message.error('编号不能为空')
                return
            }
            if (this.info.receivableMoney > 0) {
                if (!this.confirm.time2) {
                    this.$message.error('回款日期不能为空')
                    return
                }
            }

            if (this.isTodayFlage) {
                _this.loading = true
                var myDate = new Date();
                this.confirm.time = myDate.getFullYear() + '-' + (myDate.getMonth() + 1) + '-' + myDate.getDate() + ' ' + myDate.getHours() + ':' + myDate.getMinutes() + ':' + myDate.getSeconds()
            }
            var data = {
                Id: this.id,
                ManageUserId: getStorageUserRoleId(),
                Platform: 'zyd',
                InvoiceDt: this.confirm.time,
                InvoiceNumber: this.confirm.num
            }
            if (this.confirm.time2) data.InvoiceReturnPaymentsDt = this.confirm.time2
            confirmInvoiceApi(data).then((r) => {
                _this.loading = false
                if (r.Result != 1) {
                    return this.$message.error(r.Message)
                }
                this.$message.success('确认开票成功')
                this.confirmInvoiceShow = false;
                this.detailsShow = false;
                this.$parent.GetInvoiceList()
            })


        },
        //发票信息弹窗
        open(row, tag) {
            // console.log('row:'+JSON.stringify(row));
            // console.log('tag:'+tag);
            this.loading=true;
            this.tag = tag
            this.id = row.id
            var data = {
                id: row.id,
                // platform: 'zyd',
                // manageUserId: getStorageUserRoleId(),
            }

            invoiceManagedetail(data).then((r) => {
                this.loading=false;
                if (r.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.info = r.Data
                // console.log('info:'+JSON.stringify(this.info));
                this.tableData = r.Data.Orders;
                this.eInvoiceList = r.Data.EInvoiceList
            })
            this.detailsShow = true
        },

        //获取发票信息，用于电子发票作废，重开票后刷新发票信息
        getInvoiceDetail(){
            var data = {
                id: this.id 
            }
            invoiceManagedetail(data).then((r) => {
                if (r.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.info = r.Data
                this.tableData = r.Data.Orders;
                this.eInvoiceList = r.Data.EInvoiceList
            });
        },

        //关闭发票信息弹窗
        invoiceClose() {
            this.detailsShow = false
        },
        // 关闭确认开票
        confirmInvoiceClose() {
            this.confirmInvoiceShow = false
        },
        // 关闭确认回款
        
        exportJob(){ 
  
        let data = {
            DistributionInvoiceId:this.info.InvoiceInfo.ID,
            CompanyId: 0,
            StartDate:"",
            EndDate:"",
        };

        let url =
            process.env.NODE_ENV == "development"
            ? "/api4"
            : process.env.VUE_APP_API4;
            window.open(
                url +
                "/api/JobStatistics/ExportInvoiceJob?" +
                this.parseJsonURL(data)
            );
        },
        parseJsonURL(json) {
            if (!json) return "";
            if (typeof json == "string") return json;
            return this.cleanArray(
                Object.keys(json).map(function (key) {
                if (json[key] === undefined) return "";
                return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
                })
            ).join("&");
            },
            cleanArray(actual) {
            var newArray = [];
            for (var i = 0; i < actual.length; i++) {
                if (actual[i]) {
                newArray.push(actual[i]);
                }
            }
            return newArray;
            },

        //导出的方法
        exportExcel(isItem, row) {
            require.ensure([], () => {
                // 设置Excel的表格第一行的标题
                const tHeader = [
                    '订单号',
                    '订单名称',
                    '来源',
                    '发单方',
                    '完成时间',
                    '金额',
                        '额度/余额',
                    '结算状态',
                    '备注'
                ];
                const filterVal = [
                    'OrderNo',
                    'OrderName',
                    'OrderSourceStr',
                    'SenderName',
                    'FinishDate',
                    'TotalAmount',
                    'PayType',
                    'SettlementStatus',
                    'remark'
                ];
                // 数据集
                const list = isItem == 1 ? [row] : row
                const data = this.formatJson(filterVal, list);
                // excel名称可自定义
                const excelName = isItem == 1 ? "订单信息" : '全部订单信息';
                export_json_to_excel(tHeader, data, excelName);
            });
        },
        //格式化json
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },

        //重开电子发票弹窗
        reInvoice(){
            // this.loading = true;
            var orderIds = [];
            var noteIds =this.info.NoteIds;
            var senderCode =  this.info.ApplyUserCode ;
            var distributionInvoiceId=this.info.Id;//发票Id
            if(this.info.InvoiceInfo.OrderIds!=''){
                orderIds= this.info.InvoiceInfo.OrderIds.split(',');
            }
       
            if(orderIds.length<=0){
                // this.loading = false;
                return this.$message.error('错误，订单为空')
            }
 
            var data = {
                manageUserId : getStorageUserRoleId(),
                OrderIds : orderIds,
                NoteIds : noteIds,
                UserCode :senderCode,
                DistributionInvoiceId:this.info.InvoiceInfo.ID
            }
            console.log('data:'+JSON.stringify(data));
        
            batchInvoiceEcho(data).then((r)=>{
                // this.loading = false;
                if(r.Result !=1){
                    return this.$message.error(r.Message)
                }
                this.$refs.makeInvoice.open(orderIds,[senderCode],r.Data.Invoice,noteIds,distributionInvoiceId)
            })
        }

    }
}
</script>
<style lang="scss">
.tk-head-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .tk-head-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
    }
}

.item-width {
    width: 100%;

    .el-form-item__content {
        width: calc(100% - 200px);
    }
}

.content-color {
    font-size: 16px;
    color: #333333;
}
</style>